export const Logo = ({ size = 40, showText = true }) => (
  <span className="flex items-center gap-3">
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="Bass Lab – Car Audio"
    >
      <rect width="64" height="64" rx="14" fill="#ff5500" />
      <g fill="#0a0a0c">
        <rect x="11" y="26" width="6" height="12" rx="3" />
        <rect x="21" y="18" width="6" height="28" rx="3" />
        <rect x="31" y="10" width="6" height="44" rx="3" />
        <rect x="41" y="20" width="6" height="24" rx="3" />
        <rect x="49" y="27" width="5" height="10" rx="2.5" />
      </g>
    </svg>
    {showText && (
      <span className="leading-none">
        <span className="block font-display font-bold uppercase text-xl tracking-wide text-white">
          Bass Lab
        </span>
        <span className="block text-[10px] font-semibold uppercase tracking-[0.35em] text-brand mt-1">
          Car Audio
        </span>
      </span>
    )}
  </span>
);

export default Logo;
